/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Lastupdated2Inputs */

const id_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terakhir Diperbarui:`)
};

const ms_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas Kini Terakhir:`)
};

const da_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidst Opdateret:`)
};

const de_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt aktualisiert:`)
};

const en_us2_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Updated:`)
};

const es_es2_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización:`)
};

const es_mx2_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización:`)
};

const fil_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huling Na-update:`)
};

const fr_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour :`)
};

const it_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento:`)
};

const hu_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó frissítés:`)
};

const nl_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst bijgewerkt:`)
};

const no_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sist oppdatert:`)
};

const pl_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja:`)
};

const pt_br2_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização:`)
};

const pt_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização:`)
};

const ro_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima actualizare:`)
};

const fi_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi päivitetty:`)
};

const sv_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast uppdaterad:`)
};

const vi_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật lần cuối:`)
};

const tr_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Güncelleme:`)
};

const cs_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední aktualizace:`)
};

const bg_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последна актуализация:`)
};

const ru_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее обновление:`)
};

const uk_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останнє оновлення:`)
};

const ar_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر تحديث:`)
};

const hi_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम अपडेट:`)
};

const th_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตล่าสุด:`)
};

const ja_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新：`)
};

const zh_cn2_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后更新:`)
};

const zh_hant1_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後更新：`)
};

const ko_offerdetail_achievements_lastupdated2 = /** @type {(inputs: Offerdetail_Achievements_Lastupdated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마지막 업데이트:`)
};

/**
* | output |
* | --- |
* | "Last Updated:" |
*
* @param {Offerdetail_Achievements_Lastupdated2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_lastupdated2 = /** @type {((inputs?: Offerdetail_Achievements_Lastupdated2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Lastupdated2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "da") return da_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "de") return de_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "it") return it_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "no") return no_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "th") return th_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_lastupdated2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_lastupdated2(inputs)
	return ko_offerdetail_achievements_lastupdated2(inputs)
});
export { offerdetail_achievements_lastupdated2 as "offerDetail.achievements.lastUpdated" }